import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class MwChatCallDropdown extends Component {

  get rightOffset() {
    return this.args.rightOffset ??'calc(-10% - 18px)';
  }

  @action
  startCall(videoEnabled) {
    this.args.startCall?.(videoEnabled);
  }
}
